export const initialHomeState = {
  sortBy: null,
  filteredData: [],
  showProducts: true,
  showDeluxe: false,
};
